import { createContext } from 'react';

export const RatingContext = createContext({
  ratingsList: [],
  setRatings: rating => {},
});
